import { getAuthRole, getAuthUserId } from "./authSession";

/** user_id values that may edit Filer comment / status on e-filing. */
export const EFILING_ADMIN_EXTRA_EMPLOYEE_IDS = [
  "2301ab0e-a588-40b5-8e77-3e0b31de865c",
  "1daa441a-99b6-4752-b9e7-f189b6f8dc17",
];

/** Fields only admin / allowlisted power users may change on edit. */
export const EFILING_FILER_COMMENT_RESTRICTED_FIELDS = ["other_comments"];

/** @deprecated Use EFILING_FILER_COMMENT_RESTRICTED_FIELDS */
export const EFILING_ADMIN_ONLY_FIELDS = EFILING_FILER_COMMENT_RESTRICTED_FIELDS;

export function getUserRole() {
  return getAuthRole();
}

export function getLoggedInUserId() {
  return getAuthUserId() || (localStorage.getItem("user_id") || "").trim();
}

export function isEfilingPowerUser(userId = getLoggedInUserId()) {
  return EFILING_ADMIN_EXTRA_EMPLOYEE_IDS.includes(String(userId || "").trim());
}

/** E-filing page: admin, manager, employee (not client). */
export function canAccessEfilingPage() {
  const role = getUserRole();
  return role === "admin" || role === "manager" || role === "employee";
}

/** Filer comment (other_comments) — admin and allowlisted employee only. */
export function canEditEfilingFilerComment() {
  return canEditEfilingStatus();
}

/** Status + filer comment (other_comments) — admin and allowlisted employee only. */
export function canEditEfilingStatus() {
  const role = getUserRole();
  if (role === "admin") return true;
  return isEfilingPowerUser();
}

/** @deprecated Use canEditEfilingFilerComment */
export function canEditEfilingAdminFields() {
  return canEditEfilingFilerComment();
}

/** May use edit action on e-filing rows. */
export function canEditEfilingRecord() {
  const role = getUserRole();
  return role === "admin" || role === "manager" || role === "employee";
}

/** Query params for list APIs by role. */
export function getEfilingListQueryParams(extra = {}) {
  const role = getUserRole();
  const userId = getLoggedInUserId();
  if (role === "admin" || isEfilingPowerUser()) {
    return { ...extra };
  }
  if (role === "manager") {
    return { ...extra, scope: "team", manager_id: userId };
  }
  if (role === "employee") {
    return { ...extra, scope: "assigned", assigned_by: userId };
  }
  return { ...extra };
}
